import {RegistrationExternalLinkHandler} from "../../registration.external-link-handler";
import {IOpenRegistrationOptions} from "../../registration.external-link-handler.interface";

export class MichiganRegistrationExternalLinkHandler extends RegistrationExternalLinkHandler {
    async openRegistration(options?: IOpenRegistrationOptions): Promise<void> {
        try {
            await this.services.stateOfResidenceIdentifier.displayStateSelectorPopup();
        } catch (err) {
            this.services.logger.debug('State selector popup canceled', err);
            return;
        }

        return await super.openRegistration(options);
    }
}